<template>
  <div>
    <!-- 乐播媒资表单 -->
    <el-form ref="mediaForm" :model="mediaForm" :rules="rules" label-width="160px" :validate-on-rule-change="false">
      <el-form-item label="内容名称：" prop="title">
        <el-input v-model="mediaForm.title" maxlength="99" size="small" clearable placeholder="内容标题"></el-input>
      </el-form-item>
      <el-form-item label="内容图片：" prop="coverImg" ref="coverImg">
        <el-upload
          class="avatar-uploader"
          :before-upload="fileCheck"
          :http-request="(params) => upload(params, 'coverImg')"
          :show-file-list="false"
        >
          <el-image v-if="mediaForm.coverImg" :src="mediaForm.coverImg" fit="contain" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="高清封面图片：" prop="hdCoverImg" ref="hdCoverImg">
        <el-upload
          class="avatar-uploader"
          :before-upload="fileCheck"
          :http-request="(params) => upload(params, 'hdCoverImg')"
          :show-file-list="false"
        >
          <el-image v-if="mediaForm.hdCoverImg" :src="mediaForm.hdCoverImg" fit="contain" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="图片宽度尺寸：" prop="imgSelectWidth">
        <div>
          <el-radio-group v-model="mediaForm.imgSelectWidth">
            <el-radio label="300">小图：300px (推荐)</el-radio>
            <el-radio label="700">大图：700px (推荐)</el-radio>
            <el-radio :label="-1">自定义图片宽度</el-radio>
          </el-radio-group>
          <el-popover placement="top-start" width="200" trigger="hover" content="如果输入了自定义图片宽度，以自定义图片宽度为准">
            <i class="el-icon-question" slot="reference" style="margin-left: 40px;color: #507dc5;"></i>
          </el-popover>
        </div>
        <el-input
          v-if="mediaForm.imgSelectWidth === -1"
          v-model="mediaForm.customImgWidth"
          size="small"
          style="width: 400px;"
          clearable
          placeholder="请输入图片宽度(单位px)"
        ></el-input>
      </el-form-item>
      <el-form-item label="显示顺序：" prop="displayOrder">
        <el-input v-model="mediaForm.displayOrder" size="small" clearable placeholder="按照顺序进行显示，相同数字按时间排序"></el-input>
      </el-form-item>
      <el-form-item label="热度值：" prop="hotScore">
        <el-input v-model="mediaForm.hotScore" size="small" clearable placeholder="输入整数"></el-input>
      </el-form-item>
      <el-form-item label="推荐标签：" prop="recommendedTags">
        <el-input v-model="mediaForm.recommendedTags" maxlength="99" size="small" clearable placeholder="推荐标签"></el-input>
      </el-form-item>
      <el-form-item label="响应方式：" prop="skipType">
        <div>{{ getSkipTypeText }}</div>
      </el-form-item>
      <el-form-item label="宣传标签：" prop="tags">
        <el-input v-model="mediaForm.tags" maxlength="99" size="small" clearable placeholder="宣传标签"></el-input>
      </el-form-item>
      <el-form-item label="内容标签：" prop="category">
        <!-- 内容标签 -->
        <el-input
          v-model="mediaForm.categoryInput"
          size="small"
          style="width: 200px;margin-right: 10px;"
          placeholder="输入文案"
        ></el-input>
        <el-button
          size="small"
          @click="insertCategory"
        >添加</el-button>
        <div style="margin-top: 10px;">
          <el-tag
            style="margin-right: 10px;"
            closable
            v-for="( item, index ) in contentList"
            :key="item"
            @close="(() => { mediaForm.category = contentList.filter((tag, i) => i !== index).join(',') })"
          >{{ item }}</el-tag>
        </div>
      </el-form-item>
      <el-form-item label="描述：" prop="description">
        <el-input v-model="mediaForm.description" maxlength="99" size="small" clearable placeholder="输入文案"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input
          show-word-limit
          maxlength="9999"
          type="textarea"
          size="small"
          v-model="mediaForm.remark"
          placeholder="请输入备注"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <el-radio-group v-model="mediaForm.status">
          <el-radio :label="1">生效</el-radio>
          <el-radio :label="0">失效</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 生效模式 -->
      <el-form-item v-if="mediaForm.status === 1" label="选择" prop="effectMode">
        <!-- 立即生效 1  指定时间生效 2 -->
        <el-radio-group v-model="mediaForm.effectMode">
          <el-radio :label="1">立即生效</el-radio>
          <el-radio :label="2">指定时间生效</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 生效时间 -->
      <el-form-item v-if="mediaForm.status === 1 && mediaForm.effectMode === 2" label="生效时间" prop="effectTime">
        <el-date-picker
          size="small"
          :picker-options="{ disabledDate(time) {
              return time.getTime() < Date.now() - 8.64e7;
            }
          }"
          v-model="mediaForm.effectTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="生效开始时间"
          end-placeholder="生效结束时间"
          clearable
        ></el-date-picker>
      </el-form-item>
      <!-- 保存和取消按钮 -->
      <div class="btn-container" style="text-align: right; margin-top: 20px">
        <el-button size="small" type="primary" @click="save">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
import Message from '@/components/Message';
import { updateListContent } from '@/api/listContentManage/index'
import { extractWidth, processImageUrl } from '@/util/pic'
import { skipTypeList } from "@/views/mediaManage/mediaContentManage/option";

export default {
  name: 'mediaForm',
  data() {
    return {
      /** 日期选择配置 */
      pickerOptions: {
        onPick({ maxDate, minDate }) {
          if (maxDate) {
            maxDate.setSeconds(0);
          }
          if (minDate) {
            minDate.setSeconds(0);
          }
        }
      },
      /** 表单 */
      mediaForm: {},
      /** 验证规则 */
      rules: {
        // 内容名称
        title: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const formValue = this.mediaForm.title
              if (!formValue) {
                return callback(new Error('该项为必填项'));
              }
              if (formValue.length > 99) return callback(new Error('输入内容不能超过 99 个字符'));
              callback();
            },
            trigger: 'change'
          }
        ],
        // 内容图片
        coverImg: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const formValue = this.mediaForm.coverImg
              if (!formValue) {
                return callback(new Error('内容图片必须上传'));
              }
              callback();
            },
            trigger: 'change'
          }
        ],
        // 排序值
        displayOrder: [
          {
            required: false,
            validator: (rule, value, callback) => {
              let formValue = this.mediaForm.displayOrder;
              if (formValue && !/^[1-9]\d*$/.test(formValue.toString())) {
                callback(new Error('请输入正整数'));
              } else {
                callback();
              }
            },
            trigger: ['change', 'blur']
          }
        ],
        // 热度值
        hotScore: [
          {
            required: false,
            validator: (rule, value, callback) => {
              let formValue = this.mediaForm.hotScore;
              if (formValue && !/^[0-9]\d*$/.test(formValue.toString())) {
                callback(new Error('请输入整数'));
              } else {
                callback();
              }
            },
            trigger: ['change', 'blur']
          }
        ],
        // 宣传标签
        tags: [{
          validator: (rule, value, callback) => {
            let formValue = this.mediaForm.tags;
            if (formValue && formValue.length > 99) {
              callback(new Error('输入内容不能超过 99 个字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        // 描述
        description: [{
          validator: (rule, value, callback) => {
            let formValue = this.mediaForm.description;
            if (formValue && formValue.length > 99) {
              callback(new Error('输入内容不能超过 99 个字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        /** 状态 */
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        /** 生效模式 */
        effectMode: [
          { required: true, message: "请选择生效模式", trigger: "blur" },
        ],
        /** 生效时间 */
        effectTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log("生效时间", value);
              if (!value) {
                callback(new Error("请选择生效时间"));
              } else {
                // 校验开始时间，大于当前时间
                if (value[0]) {
                  // 将字符串格式的开始时间转换为Date对象
                  const startTime = new Date(value[0]);

                  // 检查转换是否成功，且开始时间是否大于当前时间
                  if (
                    isNaN(startTime.getTime()) ||
                    startTime.getTime() < Date.now()
                  ) {
                    callback(new Error("生效开始时间不能小于当前时间"));
                  }
                }
                if (value[1]) {
                  // 将字符串格式的结束时间转换为Date对象
                  const endTime = new Date(value[1]);

                  // 检查转换是否成功，且结束时间是否大于开始时间
                  if (
                    isNaN(endTime.getTime()) ||
                    endTime.getTime() < new Date(value[0]).getTime()
                  ) {
                    callback(new Error("生效结束时间不能小于开始时间"));
                  }
                }
                callback();
              }
            },
            trigger: "blur",
          }
        ]
      }
    }
  },
  computed: {
    contentList() {
      return this.mediaForm.category && this.mediaForm.category.length && this.mediaForm.category.split(',')
    },
    // 获取相应方式文案
    getSkipTypeText() {
      const skipType = skipTypeList.find(item => item.value === this.mediaForm.skipType)
      return skipType ? skipType.label : '--'
    }
  },
  methods: {
    // 检验图片宽度字段
    validateImageWidth() {
      // 校验图片宽度是否填写
      if (this.mediaForm.imgSelectWidth === -1 && !this.mediaForm.customImgWidth) {
        Message.error('请输入图片宽度');
        return false;
      }

      // 校验宽度格式 (正整数) 范围是1-1000
      if (this.mediaForm.customImgWidth && !/^(19[0-1][0-9]|1920|[1-9]\d{0,2}|[1-8]\d{2})$/.test(this.mediaForm.customImgWidth)) {
        Message.error('请输入1-1920的正整数的图片宽度');
        return false;
      }

      return true;
    },
    /** 上传图片校验 */
    fileCheck(file) {
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Message.error("目前只支持jpg/png图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error("不能上传超过2M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params, itemName) {
      const file = params.file;
      let mediaForm = new FormData();
      mediaForm.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          mediaForm,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("上传图片的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          /** 赋值 */
          this.mediaForm[itemName] = result.link;
          this.$refs.mediaForm.validateField(itemName);
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    // 添加内容标签
    insertCategory() {
      /** 取到输入框的数据 */
      const categoryInput = this.mediaForm.categoryInput
      if (categoryInput) {
        /** 第一次不要加逗号 */
        this.mediaForm.category && (this.mediaForm.category += ',')
        this.mediaForm.category += categoryInput
        this.mediaForm.categoryInput = ''
      }
    },
    // 处理回显数据
    initMediaForm(row) {
      console.log("获得的表单数据", row);
      const { id, mediaAssetId, title, coverImg, hdCoverImg, displayOrder, hotScore, recommendedTags, skipType, tags, category, description, remark, status, effectMode, effectStartTime, effectEndTime } = row;
      let initFormData = {
        id,
        mediaAssetId,
        title,
        coverImg,
        hdCoverImg,
        displayOrder,
        hotScore,
        recommendedTags,
        skipType,
        tags,
        category,
        description,
        remark,
        status,
        effectMode
      }
      if (effectMode) {
        effectMode === 2 && (initFormData.effectTime = [effectStartTime, effectEndTime])
      } else {
        initFormData.effectMode = 1
      }
      initFormData.status = status === 0 ? 0 : 1
      const width = extractWidth(coverImg)
      if (['300', '700'].includes(width)) {
        initFormData.imgSelectWidth = width
      } else {
        /** 如果是旧的图片会找不到宽度 那么就默认选择300 */
        if (!width) {
          initFormData.imgSelectWidth = '300'
        } else {
          initFormData.imgSelectWidth = -1
          initFormData.customImgWidth = width
        }
      }

      return initFormData
    },
    /** 获得表单数据的方法 */
    getForm(row) {
      const formData = this.initMediaForm(row);
      console.log("格式化后的表单数据", formData);
      this.$set(this, "mediaForm", formData)
    },
    // 保存时格式化参数
    formatMediaData() {
      const { status, effectTime, imgSelectWidth, customImgWidth, ...otherP } = this.mediaForm
      let newFormData = {
        status,
        ...otherP,
      }
      /** 如果是失效 */
      status === 0 && (newFormData.effectMode = null)
      /** 如果指定有效时间 */
      if (newFormData.effectMode === 2) {
        newFormData.effectStartTime = effectTime[0]
        newFormData.effectEndTime = effectTime[1]
      } else {
        newFormData.effectStartTime = null
        newFormData.effectEndTime = null
      }

      if (imgSelectWidth !== -1) {
        newFormData.coverImg = processImageUrl(newFormData.coverImg, imgSelectWidth)
      } else {
        /** 自定义输入图片宽度时 */
        customImgWidth && (newFormData.coverImg = processImageUrl(newFormData.coverImg, customImgWidth))
      }

      return newFormData
    },
    /** 保存 */
    save() {
      this.$refs.mediaForm.validate(async (valid) => {
        if (valid) {
          if (!this.validateImageWidth()) {
            return;
          }
          const param = this.formatMediaData()
          console.log("表单验证通过", param);
          try {
            const { data } = await updateListContent(param);
            if (data.code === 200) {
              Message.success("保存成功");
              this.$emit('reload');
              this.cancel();
            } else {
              Message.error(data.message);
            }
          } catch (error) {
            throw new Error(error);
          }
        } else {
          console.log("表单验证失败");
        }
      });
    },
    /** 关闭的方法 */
    cancel() {
      this.$refs.mediaForm.clearValidate();
      this.mediaForm = {}
      this.$emit("close");
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  min-height: 70px !important;
}

.teamInfo {
  display: flex;
  align-items: flex-end;

  .left {
    margin-right: 20px;
    display: flex;
    flex-direction: column;
  }

  .right {
    flex: 1;

    .custom-width {
      position: relative;
    }

    .tip-icon {
      position: absolute;
      top: 0;
      left: 140px;
    }
  }
}

// .link {
//   position: relative;
//   height: 200px;
// }

.link-container {
  // position: absolute;
  // left: -100px;
  padding: 20px;
  // width: 100%;
  background-color: #f5f5f5;
}

//^ ^--------------上传图片样式-------------^ ^
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  background-color: #f5f7fa;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
